import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bulkLockMainDealersBettingRules } from "@/api/mainDealers";
import { MainDealersQueryKeys } from "@/tanstackQuery/queries/mainDealers/mainDealersQueryKeys";

export const useBulkLockMainDealersBettingRules = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: bulkLockMainDealersBettingRules,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MainDealersQueryKeys.All],
      });
    },
  });
};
